// extracted by mini-css-extract-plugin
export default {"modalContent":"zi-z"};